import { useIntl } from "react-intl";
import type { DataTableColumn } from "~components/DataTable/types/dataTableColumn.ts";
import { RosterTableColumns } from "~pages/Roster/enums/rosterTableColumns.ts";
import type { RosterDataTableRow } from "~pages/Roster/types/rosterDataTableRow.ts";

export const useSharedRosterCapsColumn = <TRow extends RosterDataTableRow>(): DataTableColumn<TRow> => {
  const { formatMessage } = useIntl();

  return {
    key: RosterTableColumns.Caps,
    title: formatMessage({ id: "roster.caps" }),
    dataIndex: "caps",
    width: 70,
  };
};
